
import { Component, Prop, Mixins } from 'vue-property-decorator';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';

@Component
export default class EmailVerificationWarning extends Mixins(WithRequestManager) {
  @Prop({ required: true }) email!: string;

  private resentCode = false;

  requestManagerConfig = {
    exposeToParent: false,
  };

  resendVerificationCode() {
    if (this.resentCode) {
      return;
    }
    this.requestManager
      .currentOrNew('resendVerification', this.$services.registration.resendRegistrationConfirmation(this.email))
      .subscribe(
        () => {
          this.resentCode = true;
        },
        () => {
          this.$router.push('/login');
        }
      );
  }
}
